import BuildingService from '../../services/BuildingService'
import MasterplanService from '../../services/MasterplanService'
import AxiosErrorHandler from '../../helpers/AxiosErrorHandler'
import router from '../../router'
import ProjectsService from '../../services/ProjectsService'

export const namespaced = true

const initialState = {
  buildings: [],
  selectedBuilding: null
}

export const state = {
  buildings: [],
  selectedBuilding: null,
  projectBuildings: []
}

export const mutations = {
  SET_BUILDINGS(state, recs) {
    state.buildings = recs
  },
  SET_SELECTED_BUILDING(state, rec) {
    state.selectedBuilding = rec
  },
  SET_PROJECT_BUILDINGS(state, rec) {
    state.projectBuildings = rec
  },
  RESET_STORE(state) {
    Object.assign(state, initialState)
  }
}

export const actions = {
  fetchBuildings: function(context, value) {
    // fetch buildings for masterplan
    //context.commit("SET_BUILDINGS", value);
    let masterplanId
    if (value) {
      masterplanId = value
    } else {
      masterplanId =
        context.rootGetters['MasterplanStore/getSelectedMasterplanId']
    }
    return MasterplanService.getBuildingsForMasterplan(masterplanId).then(
      r => {
        context.commit('SET_BUILDINGS', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_BUILDINGS', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  fetchProjectBuildings: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return ProjectsService.getProjectBuildings(
      context.rootGetters['ProjectStore/getSelectedProjectId']
    ).then(
      r => {
        context.commit('SET_PROJECT_BUILDINGS', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_PROJECT_BUILDINGS', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  setSelectedBuilding: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return BuildingService.getBuildingById(value).then(
      r => {
        context.commit('SET_SELECTED_BUILDING', r.data)
        context.dispatch(
          'BreadcrumbsStore/add',
          {
            text: 'BUILDING ',
            name: r.data.name
          },
          { root: true }
        )
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_SELECTED_BUILDING', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
    // .then(
    // 	BuildingService.getPoisForBuilding(value).then(
    // 		r => {
    // 			context.dispatch("PoiStore/setPois", r.data, {
    // 				root: true
    // 			});
    // 			context.commit("SET_LOADING_STATUS", "idle", { root: true });
    // 		},
    // 		e => {
    // 			context.commit("SET_LOADING_STATUS", "idle", { root: true });
    // 			AxiosErrorHandler.handler(e, context, router);
    // 		}
    // 	)
    // );
  },
  addBuilding: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })

    return BuildingService.addBuilding(value).then(
      context.dispatch('fetchBuildings')
    )
  },
  updateBuilding: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })

    return BuildingService.updateBuilding(value).then(
      res => {
        context.commit('SET_SELECTED_BUILDING', res.data)
        context.dispatch(
          'BreadcrumbsStore/update',
          {
            text: 'BUILDING ',
            name: res.data.name
          },
          { root: true }
        )
        const projectId = context.rootGetters['ProjectStore/getSelectedProjectId']
        if (projectId) {
          context.dispatch('fetchProjectBuildings', { root: true })
        }
        context.dispatch(
          'NotificationStore/add',
          { type: 'info', message: 'Building data successfully updated' },
          { root: true }
        )
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  deleteBuilding: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    try {
      return await BuildingService.deleteBuilding(value)
    } catch (error) {
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      AxiosErrorHandler.handler(error, context, router)
      throw error
    }
  },
  resetStore: async function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    context.commit('RESET_STORE')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  }
}

export const getters = {
  getSelectedBuildingId: state => {
    return state.selectedBuilding ? state.selectedBuilding.id : 0
  }
}
